import { Typography } from '@mui/material'

const Loader = (): JSX.Element => <Typography variant="body1">Loading...</Typography>

export default Loader